
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Grading_methods_for_immature_teratoma',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Onco/Grading_methods_for_immature_teratoma.vue